const isEmptyObject = <T extends object>(obj: T) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
};

const compareTwoVariables = <T extends object>(obj1: T, obj2: T): boolean => {
  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  if (typeof obj1 === 'object' && obj1 !== null && obj2 !== null) {
    const keys1 = Object.keys(obj1) as (keyof T)[];
    const keys2 = Object.keys(obj2) as (keyof T)[];

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!compareTwoVariables(obj1[key] as T, obj2[key] as T)) {
        return false;
      }
    }

    return true;
  }

  return obj1 === obj2;
};

type DirtyField<T> = Partial<Record<string, T[keyof T]>>;

export function checkDirtyField<T extends object>(
  initialValues: T,
  currentValues: T,
): { dirtyField?: DirtyField<T>; isDirty: boolean } {
  const dirtyField: DirtyField<T> = {};

  Object.entries(initialValues).forEach(([key, initialValue]) => {
    const currentValue = currentValues[key as keyof T];

    if (currentValue !== undefined && initialValue !== undefined && !compareTwoVariables(initialValue, currentValue)) {
      dirtyField[key] = currentValue;
    }
  });

  return {
    dirtyField: isEmptyObject(dirtyField) ? undefined : dirtyField,
    isDirty: Object.keys(dirtyField).length > 0,
  };
}
